import React from 'react';
import { useTranslation } from 'react-i18next';
import formatDate from 'utils/formatDate';
import { Tabs, TabsPanel } from '@ktag/styleguide/dist/react';
import { useLocation } from 'react-router-dom';

interface Props {
  currentDate: string;
}

const OverviewToggle = ({ currentDate }: Props) => {
  const { t } = useTranslation('wap');
  const { pathname } = useLocation();

  return (
    <Tabs noBezel type="button-large" additionalClassNames="wap__overview-toggle">
      <TabsPanel label={formatDate(currentDate)} hash="/" id="current" />
      <TabsPanel
        label={t('archive')}
        hash="/archiv"
        initialActive={pathname.startsWith('/archiv')}
        id="archive"
      />
    </Tabs>
  );
};

export default OverviewToggle;
